import React, { FC } from 'react';
import { Button, Checkbox, Form, FormProps, Input, Select } from 'antd';
import { useMutation, useQuery } from 'react-query';
import { ApiClient } from '../../../api';

interface IProps extends FormProps {
    closeModal: () => void;
    record: any;
}

const EditSubscriptionForm: FC<IProps> = ({ closeModal, record, ...props }) => {
    const { data, isFetching } = useQuery('allGames', ApiClient.fetchAllGames, {
        refetchOnWindowFocus: false,
    });

    const update = useMutation(ApiClient.updateSubscription, {
        onSuccess: () => {
            ApiClient.showSuccess('Subscription successfully updated');
        },
    });

    const onFinish = (values: any) => {
        update.mutate(
            { id: record.id, ...values, numberOfFreePlays: parseFloat(values?.numberOfFreePlays) },
            {
                onSuccess: () => {
                    closeModal();
                },
                onError: (e: any) => {
                    ApiClient.showError(e?.response?.data?.message || 'Something went wrong');
                },
            },
        );
    };
    const allGames = data?.data || [];

    return (
        <Form layout={'vertical'} {...props} onFinish={onFinish} initialValues={record}>
            <Form.Item label={'Name'} name="name" rules={[{ required: true, message: 'Please enter name' }]}>
                <Input placeholder={'Enter Name'} className={'weplay-input'} />
            </Form.Item>
            <Form.Item
                label={'Number of Free Plays'}
                name="numberOfFreePlays"
                rules={[{ required: true, message: 'Please enter number of free plays' }]}
            >
                <Input placeholder={'Enter Number of Free Plays'} className={'weplay-input'} type="number" />
            </Form.Item>

            <Form.Item label={'Select Games'} name="gameRoomIds">
                <Select
                    mode="multiple"
                    placeholder="Select Games"
                    allowClear
                    options={allGames.map((game: any) => ({ label: game.title, value: game.id }))}
                />
            </Form.Item>

            <Form.Item name="enableUnlimitedPracticeRoom" valuePropName="checked">
                <Checkbox>Enable Unlimited Practice Rooms</Checkbox>
            </Form.Item>
            <Form.Item style={{ textAlign: 'right', margin: 0 }}>
                <Button className={'primary-button'} htmlType={'submit'} disabled={isFetching}>
                    Save
                </Button>
            </Form.Item>
        </Form>
    );
};

export default EditSubscriptionForm;
